import {myrequest,localrequest} from 'network/myrequest.js'

export function getcookies(){
  return myrequest({
    url:'/alldatav',
    method:"POST"
  })
}

export function getalllists(){
  // console.log("kkkk");
  return myrequest({
    url:'/alllists',
    method:"POST"
  })
}

export function getallspecial(page=1,limit=60){
  return myrequest({
    url:'/allspecial',
    method:"POST",
    data:{
      page:page,
      limit:limit
    }
  })
}

export function getuploadusers(){
  return myrequest({
    url:'/uploadusers',
    method:"POST",
  })
}

export function getadvlist(){
  return myrequest({
    url:'/advlist',
    method:"POST",
  })
}

export function sendusenum(id,type){
  return myrequest({
    url:'/setusenum',
    method:"POST",
    data:{
      id,type
    }
  })
}

//details 页
export function getreferrals(refid,reftype,sucai,type){
  return myrequest({
    url:'/getreferrals',
    method:"POST",
    data:{
      refid,reftype,sucai,type
    }
  })
}

//获取主题页数据
export function getspecialis(specialid,sucai,page){
  return myrequest({
    url:'/getspecialis',
    method:"POST",
    data:{
      specialid,sucai,page
    }
  })
}

//验证手机号是否发送过短信 是否已存在
export function testhssms(phone){
  return myrequest({
    url:'/testhssms',
    method:"POST",
    data:{
      phone
    }
  })
}
//验证手机号是否存在后台数据库当中
export function testsms(phone){
  return myrequest({
    url:'/testsms',
    method:"POST",
    data:{
      phone
    }
  })
}

//验证验证码
export function verify(ticket,randstr,phone){
  return myrequest({
    url:'/verify',
    method:"POST",
    data:{
      ticket,randstr,phone
    }
  })
}

//注册用户
export function resgist(phone,code,password,rid){
  return myrequest({
    url:'/resgist',
    method:"POST",
    data:{
      phone,code,password,rid
    }
  })
}
//修改密码验证
export function xgmmrz(phone,code,password){
  return myrequest({
    url:'/xgmmrz',
    method:"POST",
    data:{
      phone,code,password
    }
  })
}

//用户登入
export function login(phone,password){
  return myrequest({
    url:'/login',
    method:"POST",
    data:{
      phone,password
    }
  })
}

//用户登入
export function logout(){
  return myrequest({
    url:'/logout',
    method:"POST"
  })
}

//登入后发送数据到端
export function sendlogin(yh,type){
  return localrequest({
    url:'/',
    method:"GET",
    params:{
      yh,type
    }
  })
}
//发送electron 浏览器的退出状态
export function sendlogout(type){
  return localrequest({
    url:'/',
    method:"GET",
    params:{
      type
    }
  })
}

//发送electron 浏览器的退出状态
export function senditem(id,sucai,type){
  return localrequest({
    url:'/',
    method:"GET",
    params:{
      id,sucai,type
    }
  })
}